import { ITotalsServiceSummary } from "components/SummaryBanner/SummaryBanner.types";
import { CURRENCIES } from "types/bussines";
import { formatCost } from "utils/formatNumbers";
import './TotalsInServiceSummary.scss';

interface ITotalsInServiceSummaryProps {
  totals?: ITotalsServiceSummary;
}

const TotalsInServiceSummary = ({ totals }: ITotalsInServiceSummaryProps) => {
  return (
    <div className="totals">
      <p>
        Total a Pagar en USD: <strong>${formatCost(Number(totals?.totalUSD))} USD</strong>
      </p>
      {totals?.currency && totals?.currency !== CURRENCIES.USD && (
        <p>
          Total a Pagar en {totals?.currency}:{' '}
          <strong>
            ${formatCost(Number(totals?.total))} {totals?.currency}
          </strong>
        </p>
      )}
    </div>
  );
};

export default TotalsInServiceSummary;
